const url = 'https://elyqxapi.eelian.com.cn'; 
// const url = 'https://yiqixueapitest.fooktech.cn'; 
export default url
